import styled from "@emotion/styled";
import { BASE_COLORS } from "../../../emotion-theme";
import { CircleIconProps } from "./circle-icon.props";

export const CircleIcon = styled.div`
  background-color: ${(props: CircleIconProps) =>
    props.variant === "hollow" ? "none" : BASE_COLORS.lightGrey};
  border: ${(props: CircleIconProps) =>
    props.variant === "hollow" ? `solid 2px ${BASE_COLORS.lightGrey}` : "none"};

  color: ${(props: CircleIconProps) =>
    props.variant === "hollow" ? `${BASE_COLORS.slightLightGray}` : `#000`};

  border-radius: 50%;

  padding: 8px;
  margin: 16px 8px;
  text-align: center;
  overflow: hidden;
  width: 52px;
  height: 52px;
  line-height: 44px;
  vertical-align: middle;

  &:hover,
  &.active {
    cursor: pointer;
    color: ${BASE_COLORS.navyBlue};
    background-color: ${BASE_COLORS.paleBlue};
  }
`;
